import { atom } from 'jotai';
import _noop from 'lodash/noop';
import type { MetricsTrackerT } from './types';
export const DEFAULT_VALUE: MetricsTrackerT = {
  incrementCount: _noop,
  captureLatency: _noop,
  captureHistogram: _noop
};
export const metricsTrackerAtom = atom<MetricsTrackerT>(DEFAULT_VALUE);